/**
 * Класс по работе с кнопкой переключателем
 */
export default class ToggleButton {
    private $holder: JQuery;
    private ACTIVE_CLASS = 'active';

    private selectors = {
        toggleItem: '.js-toggle-item',
    }

    constructor($holder: JQuery) {
        this.$holder = $holder;

        this.clickToggleHandler = this.clickToggleHandler.bind(this);
        this.init();
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void
    {
        this.$holder.on('click', this.selectors.toggleItem, this.clickToggleHandler)
    }

    /**
     * Функция обработчик клика
     * @param event
     * @private
     */
    private clickToggleHandler(event): void {
        const $target = $(event.currentTarget);
        const $toggleItems = this.$holder.find(this.selectors.toggleItem);
        const index = $target.index();

        $toggleItems.removeClass(this.ACTIVE_CLASS);
        $target.addClass(this.ACTIVE_CLASS);
        this.$holder
            .removeClass('left')
            .removeClass('right');

        (index === 0) ?
            this.$holder.addClass('left') :
            this.$holder.addClass('right');
    }
}
